module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"notification":"All prices include 20% VAT"},"ru":{"notification":"Цена всех услуг указана с учетом НДС 20%"}}')
  delete Component.options._Ctor
}
